/**
 * Created by eguchiryo on 2019/05/22.
 */
const s3_base_url_ANALYSE = "https://s3-ap-northeast-1.amazonaws.com/to-on-services/static/burgmuller/analyse/18/";
const s3_base_url_CODE = "https://s3-ap-northeast-1.amazonaws.com/to-on-services/static/burgmuller/code/18/";
const image_prefix = "burgmuller18_"
const p1 = "p1.png";
const p2 = "p2.png";

export const Burg18Books = [
  {
    No:1,
    // title: '内緒話',
    analyse_image1: s3_base_url_ANALYSE + image_prefix + '1' + '_' + p1,
    analyse_image2: s3_base_url_ANALYSE + image_prefix + '1' + '_' + p2,
    code_image1: s3_base_url_CODE + image_prefix + '1' + '_' + p1,
    code_image2: s3_base_url_CODE + image_prefix + '1' + '_' + p2
  },
  {
    No:2,
    // title: '真珠',
    analyse_image1: s3_base_url_ANALYSE + image_prefix + '2' + '_' + p1,
    analyse_image2: s3_base_url_ANALYSE + image_prefix + '2' + '_' + p2,
    code_image1: s3_base_url_CODE + image_prefix + '2' + '_' + p1,
    code_image2: s3_base_url_CODE + image_prefix + '2' + '_' + p2
  },
  {
    No:3,
    // title: '家路につく牧人',
    analyse_image1: s3_base_url_ANALYSE + image_prefix + '3' + '_' + p1,
    analyse_image2: s3_base_url_ANALYSE + image_prefix + '3' + '_' + p2,
    code_image1: s3_base_url_CODE + image_prefix + '3' + '_' + p1,
    code_image2: s3_base_url_CODE + image_prefix + '3' + '_' + p2
  },
  {
    No:4,
    // title: 'ボヘミアン',
    analyse_image1: s3_base_url_ANALYSE + image_prefix + '4' + '_' + p1,
    analyse_image2: s3_base_url_ANALYSE + image_prefix + '4' + '_' + p2,
    code_image1: s3_base_url_CODE + image_prefix + '4' + '_' + p1,
    code_image2: s3_base_url_CODE + image_prefix + '4' + '_' + p2
  },
  {
    No:5,
    // title: '泉',
    analyse_image1: s3_base_url_ANALYSE + image_prefix + '5' + '_' + p1,
    analyse_image2: s3_base_url_ANALYSE + image_prefix + '5' + '_' + p2,
    code_image1: s3_base_url_CODE + image_prefix + '5' + '_' + p1,
    code_image2: s3_base_url_CODE + image_prefix + '5' + '_' + p2
  },
  {
    No:6,
    // title: '陽気な女',
    analyse_image1: s3_base_url_ANALYSE + image_prefix + '6' + '_' + p1,
    analyse_image2: s3_base_url_ANALYSE + image_prefix + '6' + '_' + p2,
    code_image1: s3_base_url_CODE + image_prefix + '6' + '_' + p1,
    code_image2: s3_base_url_CODE + image_prefix + '6' + '_' + p2
  },
  {
    No:7,
    // title: '子守歌',
    analyse_image1: s3_base_url_ANALYSE + image_prefix + '7' + '_' + p1,
    analyse_image2: s3_base_url_ANALYSE + image_prefix + '7' + '_' + p2,
    code_image1: s3_base_url_CODE + image_prefix + '7' + '_' + p1,
    code_image2: s3_base_url_CODE + image_prefix + '7' + '_' + p2
  },
  {
    No:8,
    // title: 'アジタート',
    analyse_image1: s3_base_url_ANALYSE + image_prefix + '8' + '_' + p1,
    analyse_image2: s3_base_url_ANALYSE + image_prefix + '8' + '_' + p2,
    code_image1: s3_base_url_CODE + image_prefix + '8' + '_' + p1,
    code_image2: s3_base_url_CODE + image_prefix + '8' + '_' + p2
  },
  {
    No:9,
    // title: '朝課の鐘',
    analyse_image1: s3_base_url_ANALYSE + image_prefix + '9' + '_' + p1,
    analyse_image2: s3_base_url_ANALYSE + image_prefix + '9' + '_' + p2,
    code_image1: s3_base_url_CODE + image_prefix + '9' + '_' + p1,
    code_image2: s3_base_url_CODE + image_prefix + '9' + '_' + p2
  },
  {
    No:10,
    // title: '速さ',
    analyse_image1: s3_base_url_ANALYSE + image_prefix + '10' + '_' + p1,
    analyse_image2: s3_base_url_ANALYSE + image_prefix + '10' + '_' + p2,
    code_image1: s3_base_url_CODE + image_prefix + '10' + '_' + p1,
    code_image2: s3_base_url_CODE + image_prefix + '10' + '_' + p2
  },
  {
    No:11,
    // title: 'セレナード',
    analyse_image1: s3_base_url_ANALYSE + image_prefix + '11' + '_' + p1,
    analyse_image2: s3_base_url_ANALYSE + image_prefix + '11' + '_' + p2,
    code_image1: s3_base_url_CODE + image_prefix + '11' + '_' + p1,
    code_image2: s3_base_url_CODE + image_prefix + '11' + '_' + p2
  },
  {
    No:12,
    // title: '森での目覚め',
    analyse_image1: s3_base_url_ANALYSE + image_prefix + '12' + '_' + p1,
    analyse_image2: s3_base_url_ANALYSE + image_prefix + '12' + '_' + p2,
    code_image1: s3_base_url_CODE + image_prefix + '12' + '_' + p1,
    code_image2: s3_base_url_CODE + image_prefix + '12' + '_' + p2
  },
  {
    No:13,
    // title: '大雷雨',
    analyse_image1: s3_base_url_ANALYSE + image_prefix + '13' + '_' + p1,
    analyse_image2: s3_base_url_ANALYSE + image_prefix + '13' + '_' + p2,
    code_image1: s3_base_url_CODE + image_prefix + '13' + '_' + p1,
    code_image2: s3_base_url_CODE + image_prefix + '13' + '_' + p2
  },
  {
    No:14,
    // title: 'ゴンドラ漕ぎの歌',
    analyse_image1: s3_base_url_ANALYSE + image_prefix + '14' + '_' + p1,
    analyse_image2: s3_base_url_ANALYSE + image_prefix + '14' + '_' + p2,
    code_image1: s3_base_url_CODE + image_prefix + '14' + '_' + p1,
    code_image2: s3_base_url_CODE + image_prefix + '14' + '_' + p2
  },
  {
    No:15,
    // title: '風の精',
    analyse_image1: s3_base_url_ANALYSE + image_prefix + '15' + '_' + p1,
    analyse_image2: s3_base_url_ANALYSE + image_prefix + '15' + '_' + p2,
    code_image1: s3_base_url_CODE + image_prefix + '15' + '_' + p1,
    code_image2: s3_base_url_CODE + image_prefix + '15' + '_' + p2
  },
  {
    No:16,
    // title: '別れ',
    analyse_image1: s3_base_url_ANALYSE + image_prefix + '16' + '_' + p1,
    analyse_image2: s3_base_url_ANALYSE + image_prefix + '16' + '_' + p2,
    code_image1: s3_base_url_CODE + image_prefix + '16' + '_' + p1,
    code_image2: s3_base_url_CODE + image_prefix + '16' + '_' + p2
  },
  {
    No:17,
    // title: '行進曲',
    analyse_image1: s3_base_url_ANALYSE + image_prefix + '17' + '_' + p1,
    analyse_image2: s3_base_url_ANALYSE + image_prefix + '17' + '_' + p2,
    code_image1: s3_base_url_CODE + image_prefix + '17' + '_' + p1,
    code_image2: s3_base_url_CODE + image_prefix + '17' + '_' + p2
  },
  {
    No:18,
    // title: '紡ぎ歌',
    analyse_image1: s3_base_url_ANALYSE + image_prefix + '18' + '_' + p1,
    analyse_image2: s3_base_url_ANALYSE + image_prefix + '18' + '_' + p2,
    code_image1: s3_base_url_CODE + image_prefix + '18' + '_' + p1,
    code_image2: s3_base_url_CODE + image_prefix + '18' + '_' + p2
  }
]





// WEBPACK FOOTER //
// ./src/variables.js